import { AxiosHeaderValue } from 'axios';

//returns the downloaded file extension dinamically (resp.headers['Content-Type'])
export const getFileExtension = (contentType: AxiosHeaderValue | undefined) => {
  let fileExtension = '';

  if (contentType === 'image/png') {
    fileExtension = 'png';
  } else if (contentType === 'image/jpeg') {
    fileExtension = 'jpg';
  } else {
    // fallback or throw an error
    fileExtension = 'bin'; // generic binary file
  }
  return fileExtension;
};

export const trimFileName = (str: string | undefined) =>
  str
    ?.split(';')
    .map((p) => p.trim())
    .find((p) => p.startsWith('filename='))
    ?.replace('filename=', '')
    .replace(/"/g, '');
